export const ReplenishmentConfigsKey = 'replenishment-configs';
export const ReplenishmentReportsKey = 'replenishment-reports';